import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { formatDate, statusTone } from "@/lib/format";
import { toast } from "sonner";
import { MessageSquareWarning } from "lucide-react";

const CONCERN_STATUSES = ["Open", "In Progress", "Resolved", "Closed"];

export default function ClientTicketsPanel({ projectId }) {
  const [rows, setRows] = useState([]);

  const load = async () => {
    try { const { data } = await api.get(`/concerns?project_id=${projectId}`); setRows(data); } catch {}
  };
  useEffect(() => {
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [projectId]);

  const setStatus = async (c, status) => {
    try { await api.patch(`/concerns/${c.id}`, { status }); toast.success("Ticket status updated"); load(); }
    catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div className="border border-black/10 bg-white rounded-2xl lg:col-span-3" data-testid="client-tickets-panel">
      <div className="px-4 py-3 border-b border-black/10 label-caps text-royal-800 flex items-center gap-2">
        <MessageSquareWarning size={12} /> Client Tickets <span className="font-mono-tight text-neutral-500">({rows.length})</span>
      </div>
      <div className="overflow-x-auto">
        <table className="fms-table w-full" data-testid="client-tickets-table">
          <thead><tr><th>Ticket ID</th><th>Subject</th><th>Description</th><th>Date</th><th>Status</th><th>Latest Update</th></tr></thead>
          <tbody>
            {rows.map((c) => (
              <tr key={c.id} data-testid={`client-ticket-${c.id}`}>
                <td className="font-mono-tight text-xs whitespace-nowrap">{c.ticket_no || c.id.slice(0, 8).toUpperCase()}</td>
                <td className="text-sm font-medium">{c.subject}</td>
                <td className="text-xs text-neutral-600 max-w-xs whitespace-pre-wrap">{c.body}</td>
                <td className="font-mono-tight text-xs whitespace-nowrap">{formatDate(c.created_at)}</td>
                <td>
                  <select data-testid={`client-ticket-status-${c.id}`} value={c.status} onChange={(e) => setStatus(c, e.target.value)}
                    className={`px-2 py-0.5 text-xs font-mono-tight uppercase rounded border border-black/10 ${statusTone(c.status)}`}>
                    {CONCERN_STATUSES.map((s) => <option key={s}>{s}</option>)}
                  </select>
                </td>
                <td className="text-xs max-w-xs" data-testid={`client-ticket-update-${c.id}`}>
                  {c.response ? (
                    <>
                      <div className="whitespace-pre-wrap line-clamp-3">{c.response}</div>
                      <div className="text-[10px] text-neutral-500 font-mono-tight mt-1">{c.responded_by || "Studio"} · {c.responded_at ? formatDate(c.responded_at) : ""}</div>
                    </>
                  ) : <span className="text-neutral-400">—</span>}
                </td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={6} className="text-center text-neutral-500 py-6 text-sm">No client tickets raised on this project.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
